<script setup lang="ts">
/**
 * PreviewBanner —— 预览模式顶部 sticky 横幅（F08）。
 *
 * 触发条件：Showcase Store `state.isPreview === true`（启动时从
 * `?preview=<token>` query 探测，store bootstrap 切 preview client）。
 * UI = sticky 顶部 + 橙底白字 + 标题/说明 + 「返回管理端」按钮（`<a>`
 * 跳 `/admin/`，整页导航到管理端 SPA，非前台路由内跳转）。
 *
 * **普通访客零影响**：无 `?preview=` query 时 store.isPreview 恒 false，
 * 调用方（HomePage）`v-if="store.state.isPreview"` 不挂载本组件。
 *
 * 文案走 Copy Catalog `copy.preview.bannerTitle` / `bannerDescription`；
 * 颜色走 `--color-preview-banner-bg` token（ADR-0009 禁硬编码颜色）。
 */
import { copy } from '@/i18n/zh-CN';

/** 管理端 SPA 部署路径（nginx `/admin/` → 管理端静态产物，管理端 ADR-0001）。 */
const ADMIN_PATH = '/admin/';
</script>

<template>
  <div :class="$style.banner" data-testid="preview-banner" role="status">
    <div :class="$style.inner">
      <span :class="$style.title">{{ copy.preview.bannerTitle }}</span>
      <span :class="$style.description">{{ copy.preview.bannerDescription }}</span>
    </div>
    <a :class="$style.back" :href="ADMIN_PATH" data-testid="preview-back">
      {{ copy.preview.backToAdmin }}
    </a>
  </div>
</template>

<style module>
.banner {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  background: var(--color-preview-banner-bg);
  color: var(--color-bg-primary);
  padding: var(--space-1) var(--space-3);
  box-shadow: var(--shadow-card);
}

.inner {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2);
  min-width: 0;
}

.title {
  font-size: var(--font-size-base);
  font-weight: 700;
}

.description {
  font-size: var(--font-size-sm);
  opacity: 0.95;
}

.back {
  flex-shrink: 0;
  color: var(--color-bg-primary);
  font-size: var(--font-size-sm);
  font-weight: 700;
  border: 1px solid var(--color-bg-primary);
  border-radius: var(--radius-sm);
  padding: 2px var(--space-2);
  transition: background var(--template-hover-duration) ease;
}

.back:hover {
  background: rgba(255, 255, 255, 0.15);
  color: var(--color-bg-primary);
}
</style>
